<script setup>
import TaskHeader from './TaskHeader.vue';

defineProps({
  searchValue: { type: String, default: '' },
  headerTitle: { type: String, default: '' },
  viewMode: { type: String, default: 'week' },
  searchResults: { type: Array, default: () => [] },
});

const emit = defineEmits([
  'search',
  'create',
  'update:viewMode',
  'selectSearchResult',
]);
</script>

<template>
  <section
    class="flex w-full h-full gap-4 overflow-hidden justify-evenly bg-n-surface-1"
  >
    <div class="flex flex-col w-full h-full transition-all duration-300">
      <TaskHeader
        :search-value="searchValue"
        :header-title="headerTitle"
        :view-mode="viewMode"
        :search-results="searchResults"
        @search="emit('search', $event)"
        @create="emit('create')"
        @update:view-mode="emit('update:viewMode', $event)"
        @select-search-result="emit('selectSearchResult', $event)"
      />
      <main class="flex-1 overflow-hidden flex flex-col">
        <div class="px-6 pt-4">
          <slot name="stats" />
        </div>
        <div class="px-6 pt-4">
          <slot name="filters" />
        </div>
        <div
          v-if="viewMode === 'list'"
          class="w-full h-full mx-auto max-w-5xl px-6 py-4 overflow-y-auto"
        >
          <slot />
        </div>
        <div v-else class="w-full h-full px-6 py-4 overflow-y-auto">
          <slot name="calendar" />
        </div>
      </main>
    </div>
    <slot name="dialogs" />
  </section>
</template>
